<template>
  <div class="card-item transition-slow">
    <div class="info-content">
      <div class="info-item">
        <router-link class="return-link" :to="{name: 'login'}">
          <span :class="'fas fa-arrow-left'" /> Volver
        </router-link>
        <div class="info-item">
          <h2 class="login-title">¡Ingreso inválido!</h2>
        </div>
        <div class="message-box">
          <p>Usuario o contraseña son incorrectas, vuelve a intentarlo.</p>
        </div>
        <div class="developer">
          <img src="@/ui/assets/img/developer.png">
        </div>
        <div class="message-box">
          <p>Recuerda que puedes simular tu crédito hipotecario 100% online:</p>
        </div>
        <a class="button is-button-primary transition-fast" href="https://ui.creditu.com/" target="__BLANK">
          Simular
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotAvailable'
};

</script>
<style lang="css" scoped>
    .info-content {
        width: 100%;
        float:left;
        text-align: center;
        padding: 10px;
        position: relative;
    }
    .info-content .info-item .login-title{
        margin: 10px;
        font-size: 30px;
        color: #00CCD1;
        }
    .info-content .return-link {
        margin: 5px auto 10px auto;
        border-radius: 40px;
        color: #797979;
        text-align: right;
        font-size: 8px;
        position:absolute;
        font-size: 13px;
        left: 2px;
        text-decoration: none;
        top: -7px;
    }
    .info-content .message-box {
        margin: 10px auto 10px auto;
        font-size: 13px;
        width: 100%;
        padding: 10px;
        border-radius: 40px;
        color: #797979;
        text-align: center;
        }
    .info-content .login-box {
        margin: 20px auto 20px auto;
        font-size: 14px;
        background-color:var(--secondary);
        width: 30%;
        padding: 12px 40px;
        border-radius: 40px;
        color: #ffffff;
        text-decoration: none;
        display: block;
    }
    .info-content .login-box:hover{
       background-color:var(--secondary-dark);
    }
    .info-content .developer{
        margin: 10px auto 10px auto;
        width: 30%;
    }
    .button{
        margin-top: 0px;
    }
    @media (max-width: 1210px) {
        .info-content .message-box {
            font-size: 10px;
        }
    }
    @media (max-width: 1024px) {

    }
    @media (max-width: 640px) {
        .info-content .info-item .login-title{
            font-size: 25px;
        }
        .info-content .login-box {
            width: 40%;
        }
    }
    @media (max-width: 380px) {
        .info-content .message-box {
            font-size: 8px;
        }
        .info-content .info-item .login-title{
            margin: 15px;
            font-size: 25px;
        }
    }

</style>
